import React from 'react';
import { Typography } from 'antd';
import classNames from 'classnames';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

/**
 * SummaryDetails Component
 *
 * Renders detail rows with text/value pairs and info layouts
 */
export const SummaryDetails = ({ details = [] }) => {
    if (!Array.isArray(details) || details.length === 0) {
        return null;
    }

    return (
        <span className="rm-card-item block margin-top">
            {details.map((detail, idx) => {
                const rowClassName = classNames('summary-detail-row', 'rm-card-item', 'block', 'with-stroke');

                //if there is a value in the detail, render text/value pair
                if (detail.value !== undefined && detail.value !== null) {
                    return (
                        <span key={idx} className={rowClassName}>
                            <Text className="semi-bold summary-detail-text">{detail.text}</Text>
                            <Text className="semi-bold summary-detail-value">{detail.value}</Text>
                        </span>
                    );
                }
                //else if there is an info in the detail, render text/subtext/info layout
                else if (detail.info) {
                    return (
                        <span key={idx} className={rowClassName}>
                            <span className="summary-detail-content">
                                <Text className="semi-bold summary-detail-text">{detail.text}</Text>
                                <Text className="summary-detail-subtext">{detail.subtext}</Text>
                            </span>
                            {/* <InfoCircleOutlined /> */}
                        </span>
                    );
                }
            })}
        </span>
    );
};

SummaryDetails.displayName = 'SummaryDetails';

export default SummaryDetails;
